export default Object.freeze({
  TITLE: '수령자 정보 수정',
  RECEIVERNAME: '수령자명',
  RECEIVERCONTACT1: '휴대전화',
  RECEIVERCONTACT2: '일반전화',
  CUSTOMSIDNUMBER: '개인통관고유부호',
  ADDRESS: '배송 주소',
  DELIVERYMEMO: '배송메시지',
  HIGHLIGHT: '필수',
  SEARCHADDRESSBTN: '우편번호 찾기',
  MODIFYBTN: '저장',
  CANCELBTN: '취소',
  VALIDATION_NAME: '수령자명을 입력하세요',
  VALIDATION_CONTACT1: '휴대전화를 입력하세요',
  VALIDATION_CONTACT1_ERROR: '잘못된 휴대폰 번호입니다. 휴대폰 번호를 정확하게 입력하세요.',
  VALIDATION_CONTACT1_ADDRESS: '주소를 정확하게 입력하세요.',
  ALERT_SAVE: '수정되었습니다.'
});
